import ReactSelect from 'react-select'
import type { SelectProps } from './index'
import React from 'react'
import { useReactSelect } from './useReactSelect'
import { Col } from 'react-bootstrap'

export const Select = (props: SelectProps) => {
  const properties = useReactSelect(props)

  return <ReactSelect {...properties} />
}

export const MultiSelect = (props: SelectProps) => {
  const properties = useReactSelect(props)

  return <ReactSelect {...properties} isMulti={true} />
}
export const SelectOptionColumn = ({ children, className = '' }: { className?: string; children: React.ReactNode }) => {
  return <Col className={`border-bottom px-1 py-2  text-truncate ${className}`}>{children}</Col>
}
